import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/widgets/Wishlist/ui/Wishlist.tsx");
